module.exports = __webpack_public_path__ + "static/ing-787d1ee49fcdf2847ec5bcad51d6b830.png";